import React, { useMemo } from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { useTranslation } from 'react-i18next';

import { PreLoader } from './PreLoader';

const Wrapper = () => {
  return useMemo(() => <PreLoader />, []);
};

export const Boards = () => {
  const { t } = useTranslation();

  return (
    <>
      <DocumentHead title={t('Boards')} />
      <PageTemplate main={<Wrapper />} />
    </>
  );
};
